import React from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import Home from "./routes/Home";
import Location from "./routes/Location";
import MainLayout from "./components/layout/mainLayout";
import About from "./routes/About";
import Blog from "./routes/Blog";
import Article from "./routes/Article";
import Contact from "./routes/Contact";
import ScrollToTop from "./components/hooks/ScrollToTop";
import { ServicePopupProvider } from './components/services/ServicePopupContext';
import Privacy from "./routes/Privacy";

const Controller = () => {
    return (
        <ServicePopupProvider>
            <Routes>
                <Route path="/" element={
                    <MainLayout>
                        <ScrollToTop />
                        <Outlet/>
                    </MainLayout>
                }>
                    <Route path="/" element={<Home />} />
                    <Route path="/qui-sommes-nous" element={<About />} />
                    <Route path="/ou-nous-rencontrer" element={<Location />} />
                    <Route path="/articles" element={<Blog />} />
                    <Route path="/article/:id" element={<Article />} />
                    <Route path="/politique-de-confidentialite" element={<Privacy />} />
                </Route>
                <Route path="/contact" element={<Contact />} />
            </Routes>
        </ServicePopupProvider>
    );
}

export default Controller;